import React from 'react'

function SummaryStats({data}) {
     const stats = data?.summary_stats;


    return (
      <div className="flex flex-wrap mb-6 space-x-5">
        <div className="bg-blue-50 p-4 rounded-lg my-4">
          <div className="text-2xl font-bold text-blue-600">{stats.displayed_needs}</div>
          <div className="text-sm text-blue-500">Active Needs</div>
        </div>
        <div className="bg-green-50 p-4 rounded-lg my-4">
          <div className="text-2xl font-bold text-green-600">{stats.categories_count}</div>
          <div className="text-sm text-green-500">Categories</div>
        </div>
        <div className="bg-purple-50 p-4 rounded-lg my-4">
          <div className="text-2xl font-bold text-purple-600">
            {(stats.max_importance * 100).toFixed(1)}%
          </div>
          <div className="text-sm text-purple-500">Highest Priority</div>
        </div>
      </div>
    );
}

export default SummaryStats
